
import ImageMeta from "@/mixins/imageMeta.js";

export default {
  name: "RelatedPosts",
  mixins: [ImageMeta],
  props: {
    posts: Array,
    currentPostID: Number,
  },
  computed: {
    relatedPosts() {
      const currentIndex = this.posts.findIndex(
        (post) => post.id === this.currentPostID
      );

      // If array has 1 or 2 elements
      if (this.posts.length === 1) {
        return [];
      } else if (this.posts.length === 2) {
        if (currentIndex === 0) {
          return [this.posts[1]];
        } else {
          return [this.posts[0]];
        }
      }

      let startIndex = currentIndex + 1;
      let endIndex = currentIndex + 2;

      // If array has more than 2 elements
      if (currentIndex === this.posts.length - 1) {
        startIndex = 0;
        endIndex = 1;
      } else if (currentIndex === this.posts.length - 2) {
        endIndex = 0;
      }

      return [this.posts[startIndex], this.posts[endIndex]];
    },
  },
  methods: {
    mouseEvent(state, postID) {
      const image = document.getElementById('related-' + postID)

      this.$anime.remove(image);

      if (state) {
        this.$anime({
          targets: image,
          scale: 1.1,
          duration: 2000,
          easing: 'cubicBezier(0.2, 1, 0.36, 1)'
        });
      } else {
        this.$anime({
          targets: image,
          scale: 1,
          duration: 700,
          easing: 'easeOutExpo'
        });
      }
    },
  }
}
